export default __webpack_public_path__ + "img/image-widget-empty.0e3f672e.svg";